/* REVIVE flavour catalogue — shared between the deep-dive section and the buy modal */
export const REVIVE_FLAVOURS = [
  { name: "Raw Unflavoured", color: "#9CA3AF", note: "Pure mineral — mix with anything" },
  { name: "Apple", color: "#3FB54A", note: "Crisp orchard apple" },
  { name: "Blackcurrant", color: "#7E3FB5", note: "Deep, jammy, slightly tart" },
  { name: "Blood Orange", color: "#E85020", note: "Sicilian citrus — punchy" },
  { name: "Cucumber Mint", color: "#9FDDC4", note: "Spa-cool · post-workout" },
  { name: "Lemon Lime", color: "#C8E22E", note: "Classic citrus reset" },
  { name: "Peach", color: "#F1B98E", note: "Soft summer stone fruit" },
  { name: "Raspberry", color: "#E94B6A", note: "Bright, tart, berry-forward" },
  { name: "Watermelon", color: "#F47A8E", note: "Newest · summer year-round", badge: "NEW" },
];
